<template>
  <span v-if="isAvailable">
    <b-button
      :id="targetId"
      :variant="buttonVariant"
      :class="buttonClass"
    >
      <feather-icon icon="InfoIcon" />
    </b-button>

    <b-popover
      :target="targetId"
      :triggers="triggers"
      :placement="placement"
      :title="popupTitle"
      @show="loadHintPopup"
    >
      <div
        class="hint-popup-text"
      >
        {{ popupText }}
      </div>
    </b-popover>
  </span>
</template>

<script>
import {
  BButton,
  BPopover,
} from 'bootstrap-vue'

let hintPopupCounter = 0

export default {
  name: 'HintPopup',
  components: {
    BButton,
    BPopover,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    buttonVariant: {
      type: String,
      default: 'flat-primary',
    },
    buttonClass: {
      type: String,
      default: 'btn-icon rounded-circle text-center',
    },
    placement: {
      type: String,
      default: 'auto',
    },
    triggers: {
      type: [String, Array],
      default: () => ['hover'],
    },
  },
  data() {
    hintPopupCounter += 1
    return {
      targetId: `hint-popup-${hintPopupCounter}`,
      isAvailable: false,
      loading: false,
      loaded: false,
      popupTitle: '',
      popupText: '',
    }
  },
  mounted() {
    this.loadHintPopup()
  },
  activated() {
    this.loadHintPopup()
  },
  methods: {
    loadHintPopup() {
      if (this.loaded || this.loading) return

      this.loading = true

      this.$http
        .get('public.cfc?method=getHintPopupById', {
          params: {
            id: this.id,
          },
        })
        .then(response => {
          const data = response.data || {}
          const isLive = Number(data.islive !== undefined ? data.islive : data.ISLIVE) === 1

          this.loaded = true

          if (!isLive) {
            this.isAvailable = false
            return
          }

          this.popupTitle = data.title || data.TITLE || ''
          this.popupText = data.text || data.TEXT || ''
          this.isAvailable = true
        })
        .catch(() => {
          this.isAvailable = false
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.hint-popup-text {
  white-space: pre-line;
}
</style>
